<div class="d-flex flex-column gap-2" *transloco="let t">
    <span *ngIf="waitTime">{{ t('buy.wait-for-commitment', { waitTime: waitTime }) }}</span>
    <mat-progress-bar *ngIf="waitProgress" [value]="waitProgress"></mat-progress-bar>
</div>
